import ShadowQuery from './ShadowQuery.vue';
export default ShadowQuery;
